import { NumberIdentity, PolicyLiteralList } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
import { TenantId } from "../tenant/tenant-entity";
const RoleIdSchema = NumberIdentity.schema.brand();
export const RoleId = {
    schema: RoleIdSchema,
    of: (id) => RoleId.schema.parse(id),
};
const RoleNameSchema = z.string().min(1).max(32).brand();
export const RoleName = { schema: RoleNameSchema };
const PolicyLiteralsSchema = z.enum(PolicyLiteralList);
const RoleEntitySchema = z.object({
    id: RoleIdSchema,
    tenantId: TenantId.schema,
    name: RoleNameSchema,
    policies: z.array(PolicyLiteralsSchema),
});
const newRole = (args) => {
    const values = {
        id: NumberIdentity.generate(),
        ...args,
    };
    return RoleEntity.schema.parse(values);
};
const updateRole = (existingRole, updates) => {
    return RoleEntity.schema.parse({
        ...existingRole,
        ...updates,
    });
};
const createDefaultRole = (tenantId) => {
    return RoleEntitySchema.parse({
        id: NumberIdentity.generate(),
        tenantId,
        name: "NoRole",
        policies: [],
    });
};
export const RoleEntity = {
    schema: RoleEntitySchema,
    reconstruct: (args) => RoleEntity.schema.parse(args),
    newRole,
    updateRole,
    createDefaultRole,
};
//# sourceMappingURL=role-entity.js.map